// extracted by mini-css-extract-plugin
export default {"closeIcon":"Popup_closeIcon__c5Ewl","header":"Popup_header__6h+hf","textContainer":"Popup_textContainer__c4nmt","textLine":"Popup_textLine__4pvu6"};